import { gql, TypedDocumentNode } from "@apollo/client";

import {
  ApiKey,
  ApiKeyRoleBinding,
  ManagedUser,
  ManagedUserGroup,
  Role,
  UserGroupRoleBinding,
  UserRoleBinding,
} from "types/generated";

export type GetEntitiesWithRoleBindingsData = {
  managedUsers: Array<
    Pick<ManagedUser, "id" | "username"> & {
      userRoleBindings: Pick<UserRoleBinding, "id" | "roleID" | "spaceID">[];
    }
  >;
  managedUserGroups: Array<
    Pick<ManagedUserGroup, "id" | "groupName"> & {
      userRoleBindings: Pick<UserGroupRoleBinding, "id" | "roleID" | "spaceID">[];
    }
  >;
  apiKeys: Array<
    Pick<ApiKey, "id" | "name"> & {
      apiKeyRoleBindings: Array<
        Pick<ApiKeyRoleBinding, "id" | "spaceID"> & {
          role: Pick<Role, "id">;
        }
      >;
    }
  >;
};

export const GET_ENTITIES_WITH_ROLE_BINDINGS: TypedDocumentNode<GetEntitiesWithRoleBindingsData> = gql`
  query GetEntitiesWithRoleBindings {
    managedUsers {
      id
      username
      userRoleBindings {
        id
        roleID
        spaceID
      }
    }
    managedUserGroups {
      id
      groupName
      userRoleBindings {
        id
        roleID
        spaceID
      }
    }
    apiKeys {
      id
      name
      apiKeyRoleBindings {
        id
        spaceID
        role {
          id
        }
      }
    }
  }
`;
